/**
 * Publishes events to the dataLayer for Product Detail Page.
 * NO FUNCTIONAL LOGIC PERMITTED
 **/
define([
	'jquery',
	'pubsub'
	], function($,pubsub) {
		
	/**
	 * VFDP-9156
	 * Improve add to cart tracking by supporting additional events
	 **/
	$.pubsub('subscribe', 'vfdp.wcs.product_form.add_to_cart_clicked', function() {
		try {
			var $productForm = $('.product-form-js'),
				isQuickView = $productForm.closest('.quickview-box-js').length === 0 ? false : true,
				clickSource = 'fullpdp';
				if(isQuickView === true) {
					clickSource = 'quickview';		
				} 	
			window.dataLayer.push({
				'event' : 'addToCartClick',
				'clickSource' : clickSource
			});
		} catch (err) {
			console.error('Failed push to dataLayer',err);
		}
	});
	
	$.pubsub('subscribe', 'vfdp.wcs.product_form.add_to_cart_succeeded', function(message, data) {
		var productData = getProductData(data);
		var currencyData = getCurrencyData();
		pushDetailsToDataLayer(productData, currencyData, 'addToCart');
	});

	$.pubsub('subscribe', 'vfdp.wcs.product_form.add_to_wishlist_succeeded', function(message, data) {
		var productData = getProductData(data);
		var currencyData = getCurrencyData();
		pushDetailsToDataLayer(productData, currencyData, 'addToWishlist');
	});

	$.pubsub('subscribe', 'vfdp.wcs.product_form.add_to_favorites_succeeded', function(message, data) {
		var productData = getProductData(data);
		var currencyData = getCurrencyData();
		pushDetailsToDataLayer(productData, currencyData, 'addToFavorites');
	});

	$.pubsub('subscribe', 'vfdp.wcs.product_form_cart.add_to_wishlist_succeeded', function(message, data) {
		var currencyData = getCurrencyData();
		var productData = getCartProductData(data);
		if(WCS_CONFIG.get('global::favoritesEnabled') === true) {
			pushDetailsToDataLayer(productData, currencyData, 'addToFavorites');
		} else {
			pushDetailsToDataLayer(productData, currencyData, 'addToWishlist');
		}
	});

	$.pubsub('subscribe', 'product-form.attr.context.changed', function(message, data) {
		var productData = getProductData(data);
		var currencyData = getCurrencyData();
		pushDetailsToDataLayer(productData, currencyData, 'productDetailViewUpdated');
	});
	
	$.pubsub('subscribe', 'vfdp.wcs.product_form.buy_now_clicked', function(message, data) {
		var productData = getProductData(data);
		var currencyData = getCurrencyData();
		pushDetailsToDataLayer(productData, currencyData, 'buyNowClick');
	});

	//Track event when user presses on NOTIFY ME WHEN AVAILABLE button on PDP
	$.pubsub('subscribe', 'WCS.PRODUCTFORM.EVENT.NOTIFYME.ACTIVE', function(message, data) {
		try {
            window.dataLayer.push({
                'event':'eventFired',
                'eventAttributes':{
                    'type': 'userEvent',
                    'category': 'buttons',
                    'action': 'click',
                    'label': 'notifyMe:request'
                }
            });
		} catch (err) {
			console.error('Failed push to dataLayer',err);
		}
	});

	//Track event when user successfully signs up to be notified when a product is available
	$.pubsub('subscribe', 'WCS.PRODUCTFORM.EVENT.NOTIFYME.SIGNUP.SUCCESS', function(message, data) {
		try {
			window.dataLayer.push( { "event": "notifyMeSignUpSuccess" } );
		} catch (err) {
			console.error('Failed push to dataLayer',err);
		}
	});

	// Track event when user click on the notify me button after entered email
	$.pubsub('subscribe', 'WCS.PRODUCTFORM.EVENT.NOTIFYME.SUBMIT', function(message, arraySizes) {
		try {

			window.dataLayer.push({
				event: 'notifyMeSignUpSuccess',
				ecommerce: {
					detail: {
						products: [{
							notifyForSize: arraySizes.join('-')
						}]
					}
				}
			});

		} catch (err) {
			console.error('Failed push to dataLayer', err);
		}
	});

	//Track event when user presses on BUY FROM AN ONLINE DEALER button
	$.pubsub('subscribe', 'WCS.PRODUCTFORM.EVENT.ONLINEDEALER.ACTIVE', function(message, data) {
		try {
			window.dataLayer.push( { "event": "buyFromDealerClicked" } );
		} catch (err) {
			console.error('Failed push to dataLayer',err);
		}
	});

	function pushDetailsToDataLayer(productData, currencyData, event) {
		var dataLayerObj = {
			'event' : event,
			'ecommerce': {
				'currencyCode': currencyData.currencyCode ? currencyData.currencyCode : null,
				'currencySymbol': currencyData.currencySymbol ? currencyData.currencySymbol : null
			}
		};

		var productInfo = {
			'products': [{
				'name': productData.productName,
				'id': productData.productId,
				'bundleID': productData.bundleId ? productData.bundleId : null,
				'productID': productData.productId ? productData.productId : null,
				'itemID': productData.itemId ? productData.itemId : null,
				'vn': productData.itemId ? productData.itemId : null,
				'price': parseFloat(productData.unitPrice),
				'brand': '',
				'category': productData.categoryId ? productData.categoryId : "Misc",
				'variant': $.trim(productData.definingAttributes) ? $.trim(productData.definingAttributes) : '',
				'quantity': productData.quantity ? productData.quantity : 1,
				'styleCode': productData.atcProduct.styleCode || productData.productId || null,
				'colorCode': productData.atcProduct.colorCode || null,
				'colorDescription': productData.atcProduct.colorDescription || null,
				'size': productData.atcProduct.size || productData.definingAttributes.split(":").pop().trim() || ''
			}]
		};

		if (event === 'addToCart' || event === 'buyNowClick') {
			dataLayerObj.ecommerce.add = productInfo;
			dataLayerObj.atcProduct = productData.atcProduct;
		} else if (event === 'productDetailViewUpdated') {
			dataLayerObj.ecommerce.detail = productInfo;
		} else {
			dataLayerObj.ecommerce[event] = productInfo;
		}

		try {
			window.dataLayer.push(dataLayerObj);
		} catch (err) {
			console.error('Failed push to dataLayer',err);
		}
	}
	
	function getCartProductData(data) {
		var atcProduct = {
				'styleCode': data.styleCode,
				'colorCode': data.colorCode,
				'colorDescription': data.colorDescription,
				'size': data.size
			};
		data.atcProduct = atcProduct;
		return data;
	}

	function getProductData(data) {
		var $productForm = $('.product-form-js').eq(data.productFormIndex),
			currency = $("meta[property='og:price:currency']").attr("content"),
			colorItem = $productForm.find(".attr-color-js:not(.hide) .color-swatches-js .attr-box.selected .color-swatch-button-content").data("productData"),
			productCode = $productForm.data('product-part-number'),
			productNameStr = "",
			unitPriceStr = "0.00",
			attributeStr = "",
			$product,
			parentProductId = $productForm.find('input[name=catEntryId]').val(),
			childProductId = $productForm.data('child-catentry-id'),
			childPartNumber = $productForm.data('child-part-number'),
			bundlePartNumber = $productForm.data('bundle-part-number').toString(),
			seoCategory = $productForm.data('seo-category'),
			isQuickView = $productForm.closest('.quickview-box-js').length === 0 ? false : true,
			breadcrumb = $productForm.data('breadcrumb'),
			categoryId = (isQuickView ? $('.product-listing-js').data('category-identifier') : ''),
			masterCategoryId = $productForm.data('master-category-identifier'),
			quantity = $productForm.find('.quantity-js').val(),
			atcProduct = {
				'sku': productCode,
				'name': productNameStr,
				'category': masterCategoryId ? masterCategoryId : "Misc",
				'price': parseFloat(unitPriceStr),
				'vn': childPartNumber ? childPartNumber : '',
				'parentId': parentProductId ? parentProductId : '',
				'childId': childProductId ? childProductId : '',
				'bundlePartNumber': bundlePartNumber ? bundlePartNumber : '',
				'productOrigination': breadcrumb ? breadcrumb : 'search',
				'seoCategory': seoCategory ? seoCategory : '',
				'styleCode': colorItem.analyticsStyleColorCodeCheckEnabled === 'true' ? childPartNumber.split(":")[1] : colorItem.styleCode,
				'colorCode': colorItem.analyticsStyleColorCodeCheckEnabled === 'true' ? childPartNumber.split(":")[2] : colorItem.colorCode,
				'colorDescription': colorItem.colorDescription,
				'size': $productForm.find(".attr-size:not(.hide) .product-content-form-size-btn-label.selected").data("attributeValue") || $productForm.find('#attr-size:not(.hide).product-content-form-size-step-attr-size :selected').data("attributeValue") || 'One Size'
			};
	
		var $bundleInfo = $productForm.parents(".bundle-product-info-js");
		if($bundleInfo.length > 0){ //bundle
			productNameStr = $bundleInfo.find(".product-info-js").data("catentry-name-dl");
			unitPriceStr = $bundleInfo.find(".product-price-amount-js").text().match(/[0-9]+(.[0-9]+)*/g);
			unitPriceStr = (unitPriceStr === null || unitPriceStr.length < 1) ? 0.00 : parseFloat(unitPriceStr[0]);
		}else{ //PDP or QuickView
			productNameStr = $("#product-info .product-info-js:not(.hide)").data("catentry-name-dl");
	
			if( $("#product-info .product-price-amount-js").length > 0){
				$product = $("#product-info .product-price-amount-js");
			}
			else if( $("#product-form .product-price-amount-js").length > 0){
				$product = $("#product-form .product-price-amount-js");
			}
			if($product) unitPriceStr = $product.data("amount");
		}
		if($productForm.find(".attr-color-js").length > 0){
			var attributeNameElement = $productForm.find(".attr-color-js:not(.hide) .attr-primary-name-js .attr-primary-name-label").clone();
			attributeNameElement.find(".step-number").remove();
	
			attributeStr += (attributeNameElement.text() + ": " + $productForm.find(".attr-color-js:not(.hide) .attr-primary-name-js .attribute-label-value-js").text()).replace(/\t|\n|\r/g,'');
		}
	
		$productForm.find(".step-container.attribute-value-selected:not(.attr-color)").each(function(){
			var attributeNameElement = $(this).find(".attr-primary-name-js").clone();
			attributeNameElement.find(".step-number").remove();
	
			var name = attributeNameElement.text().replace(/\t|\n|\r/g,'');
			var value = $(this).find(".attr-input-js[name='attrValue']").val();
	
			attributeStr += (attributeStr.length > 0 ? " / " : "") + name;
			if(value) attributeStr += ": " + value;
		});
		attributeStr = attributeStr.replace(/[:]+/g, ':');
		atcProduct.price = parseFloat(unitPriceStr);
		atcProduct.name = productNameStr;
		
		var productData = {
			productName: productNameStr,
			productId: productCode,
			bundleId: bundlePartNumber,
			itemId: childPartNumber,
			unitPrice: unitPriceStr,
			categoryId: masterCategoryId,
			definingAttributes: attributeStr,
			quantity: quantity,
			atcProduct: atcProduct
		};
		
		return productData;
	}
	
	function getCurrencyData() {
		var currencyCode;
		var currencySymbol;
		var jsonData;
		if(window.dataLayer) {
			for(var i in window.dataLayer) {
				jsonData = window.dataLayer[i];
				currencyCode = jsonData.currency;
				currencySymbol = jsonData.currencySymbol;
				if(currencySymbol){
					currencySymbol = currencySymbol.replace(/&amp;/g, '&');
					currencySymbol = $('<textarea/>').html(currencySymbol).text();
					window.dataLayer[i].currencySymbol = currencySymbol;
					break;
				}
			}
		}
		var currencyData = {
			currencySymbol: currencySymbol,
			currencyCode: currencyCode
		};
		return currencyData;
	}
});
